import { computed } from 'vue'
import { useFormDisabled, useFormSize } from '@code-monkey-ui/components/form'
import type { BatchProps } from './batch'
export const useBatch = (props: BatchProps, useSize: any) => {
  const disabled = useFormDisabled()
  const _size = useFormSize(computed(() => useSize))
  return {
    disabled,
    _size,
    props,
  }
}
